export default {
    BASIC: 'basic',
    FORM: 'form',
};
